export default "__VITE_ASSET__cbc946be__"